module.exports = __webpack_public_path__ + "static/media/Permissiondoucment.07a96d73.svg";